<template>
    <div>
        <div v-for="index in numberOfTimelines" :key="index" class="timeline-item-sidebar">
            <div class="animated-background-sidebar">
                <div class="background-masker-sidebar masker-top-sidebar"></div>
                <div v-if="(index % 10 === 2 || index % 10 === 7)" class="background-masker-sidebar show-part-sidebar"></div>
                <div class="background-masker-sidebar masker-bottom-sidebar"></div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'TimelineSidebar',
    computed: {
        numberOfTimelines() {
            return Math.floor(this.screenHeight / this.heightBlockTimeline);
        }
    },
    methods: {
        updateScreenHeight() {
            if (!this.$parent.$el?.clientHeight) {
                throw new Error('element must have height');
            }
            this.screenHeight = this.$parent.$el.clientHeight || this.heightBlockTimeline;
        },
    },
    mounted() {
        this.updateScreenHeight();
        window.addEventListener('resize', this.updateScreenHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateScreenHeight);
    },
    data() {
        return {
            screenHeight: 0,
            heightBlockTimeline: 48
        }
    }
}
</script>
